import React from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Liv H.',
      date: 'May 2026',
      rating: 5,
      text: 'Amazing experience! The team is so professional and friendly. My balayage turned out exactly how I wanted - natural and beautiful. Will definitely be back!',
    },
    {
      name: 'Tomi A.',
      date: 'May 2026',
      rating: 5,
      text: 'Best salon in Vancouver! I have been coming here for years and they never disappoint. The color always grows out beautifully and looks so natural.',
    },
    {
      name: 'Kat D.',
      date: 'May 2026',
      rating: 5,
      text: 'I am obsessed with my hair! The balayage is perfect - exactly the sun-kissed look I wanted. The team really takes the time to understand what you want.',
    },
    {
      name: 'Kim A.',
      date: 'May 2026',
      rating: 5,
      text: 'They are amazing! I got my hair done a couple of weeks ago and it turned out beautiful. The consultation was thorough and the final result exceeded my expectations.',
    },
    {
      name: 'Livia V.',
      date: 'May 2026',
      rating: 5,
      text: 'Perfect experience from start to finish! The salon has such a lovely atmosphere and the stylists are incredibly talented. My balayage looks flawless.',
    },
    {
      name: 'Ilona I.',
      date: 'May 2026',
      rating: 5,
      text: 'I cannot recommend Prép enough! The team is wonderful, the salon is beautiful, and my hair has never looked better. Worth every penny!',
    },
  ];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="section-padding bg-gradient-to-b from-black via-[#0a0a0a] to-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#c9a961] text-sm font-semibold tracking-[0.2em] uppercase">Testimonials</span>
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl md:text-6xl font-light text-[#f8f6f0] mb-6">
            Loved by
            <span className="block text-[#c9a961]">Vancouver Locals</span>
          </h2>
          <div className="flex items-center justify-center space-x-2 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="text-[#c9a961]" size={24} fill="#c9a961" />
            ))}
          </div>
          <p className="text-[#f8f6f0]/70 text-lg">Rated 4.7 out of 5 from 400+ reviews on Fresha</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-[#1a1a1a] to-black border border-[#c9a961]/20 p-8 hover:border-[#c9a961]/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(201,169,97,0.15)] relative"
            >
              <Quote className="absolute top-6 right-6 text-[#c9a961]/20" size={40} />
              
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-[#c9a961]" size={16} fill="#c9a961" />
                ))}
              </div>

              <p className="text-[#f8f6f0]/80 leading-relaxed mb-6 relative z-10">{testimonial.text}</p>

              <div className="border-t border-[#c9a961]/20 pt-4">
                <div className="font-medium text-[#f8f6f0]">{testimonial.name}</div>
                <div className="text-[#c9a961] text-sm">{testimonial.date}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-[#f8f6f0]/70 mb-6">Read more reviews on Fresha</p>
          <div className="inline-flex items-center space-x-2 bg-[#c9a961]/10 border border-[#c9a961]/30 px-6 py-3 backdrop-blur-sm">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="text-[#c9a961]" size={18} fill="#c9a961" />
              ))}
            </div>
            <span className="text-[#f8f6f0] font-semibold">4.7/5</span>
            <span className="text-[#f8f6f0]/60">• 400+ Fresha Reviews</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
